export const toDegreesMinutesAndSeconds = (coordinate: number) => {
  const absolute = Math.abs(coordinate)
  const degrees = Math.floor(absolute)
  const minutesNotTruncated = (absolute - degrees) * 60
  const minutes = Math.floor(minutesNotTruncated)
  const seconds = Math.floor((minutesNotTruncated - minutes) * 60)
  return degrees + '°' + minutes + "'" + seconds + '"'
}

export const convertDMS = (lat, lng) => {
  const latitude = toDegreesMinutesAndSeconds(lat)
  const latitudeCardinal = lat >= 0 ? 'N' : 'S'
  const longitude = toDegreesMinutesAndSeconds(lng)
  const longitudeCardinal = lng >= 0 ? 'E' : 'W'
  return latitude + '' + latitudeCardinal + ' ' + longitude + '' + longitudeCardinal
}

export const toDegreesMinutesAndSecondsAbr = (coordinate: number) => {
  const absolute = Math.abs(coordinate)
  const degrees = Math.floor(absolute)
  const minutesNotTruncated = (absolute - degrees) * 60
  const minutes = Math.floor(minutesNotTruncated)
  const seconds = Math.floor((minutesNotTruncated - minutes) * 60)
  return degrees + '°' + minutes + '.' + seconds
}

export const convertDMSAbr = (lat, lng) => {
  const latitude = toDegreesMinutesAndSecondsAbr(lat)
  const longitude = toDegreesMinutesAndSecondsAbr(lng)
  return latitude + ', ' + longitude + ''
}

export const getDirection = (heading: number, abbr = false) => {
  if (heading > 337.5 || heading <= 22.5) {
    return abbr ? 'N' : 'North'
  } else if (heading > 22.5 && heading <= 67.5) {
    return abbr ? 'NE' : 'Northeast'
  } else if (heading > 67.5 && heading <= 112.5) {
    return abbr ? 'E' : 'East'
  } else if (heading > 112.5 && heading <= 157.5) {
    return abbr ? 'SE' : 'Southeast'
  } else if (heading > 157.5 && heading <= 202.5) {
    return abbr ? 'S' : 'South'
  } else if (heading > 202.5 && heading <= 247.5) {
    return abbr ? 'SW' : 'Southwest'
  } else if (heading > 247.5 && heading <= 292.5) {
    return abbr ? 'W' : 'West'
  } else if (heading > 292.5 && heading <= 337.5) {
    return abbr ? 'NW' : 'Northwest'
  }
}
